export const flywheel_pullover = {
  msrp: 49.99,
  infoLink: 'https://www.teamtriton.com/flywheel-pullover.html',
  items: [
    {
      number: 'FLY100',
      hasModel: false,
    },
    {
      number: 'FLY101',
      hasModel: false,
    },
    {
      number: 'FLY102',
      hasModel: false,
    },
    {
      number: 'FLY103',
      hasModel: false,
    },
    {
      number: 'FLY104',
      hasModel: false,
    },
    {
      number: 'FLY105',
      hasModel: false,
    },
    {
      number: 'FLY106',
      hasModel: false,
    },
    {
      number: 'FLY107',
      hasModel: false,
    },
    {
      number: 'FLY108',
      hasModel: false,
    },
    {
      number: 'FLY109',
      hasModel: false,
    },
  ],
};
